// extracted by mini-css-extract-plugin
module.exports = {"containerResponsive":"styles__containerResponsive___2_kzV"};